import { format } from 'date-fns'
import React, { MouseEventHandler, MutableRefObject } from 'react'
import { FiCalendar, FiX } from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import { dateFormat } from '../../../utils/DateFormat'
import { Input } from '../elements'
import FormElement from '../FormElement'
import { IFormElementProps } from '../FormElement/FormInput'
import { RangeType } from './index'

const DateRangeInput = FormElement(
  ({
    name,
    onChange,
    value,
    className,
    placeholder,
    isSelected,
    errorMsg,
    warningMsg,
    size = 1,
    onFocus,
    required,
    disabled,
    formatDate,
    isSmallReservation,
    withEmptyOnStart,
    isClear,
    isWithError,
    dateRangeRef,
    onClick,
    startDate = new Date(),
  }: IDateRangeInputProps) => {
    function dateClear(e) {
      e.stopPropagation()
      onChange('')
    }

    return (
      <React.Fragment>
        <Flex
          justifyEnd={true}
          alignCenter={true}
          style={{ position: 'relative' }}
          full={true}
          ref={dateRangeRef}
        >
          <Input
            name={name}
            placeholder={placeholder}
            selected={isSelected}
            error={errorMsg && errorMsg !== ''}
            warning={warningMsg && warningMsg !== ''}
            type={'text'}
            onFocus={onFocus}
            onChange={onChange}
            isWithError={isWithError ? !!errorMsg : false}
            onClick={onClick}
            size={size}
            required={required}
            smallReservation={isSmallReservation}
            value={
              value
                ? format(
                    value,
                    dateFormat(formatDate ? formatDate : 'dd/MM/yyyy'),
                  )
                : !withEmptyOnStart
                ? startDate
                  ? format(
                      startDate,
                      dateFormat(formatDate ? formatDate : 'dd/MM/yyyy'),
                    )
                  : ''
                : ''
            }
            disabled={disabled}
            className={className}
            readOnly={true}
            style={{ background: 'transparent', cursor: 'pointer' }}
            data-cy={className}
          />

          <Flex
            style={{
              pointerEvents: 'none',
              position: 'absolute',
              right: size ? `${10 * size}px` : '10px',
            }}
            onClick={onClick}
          >
            {isClear && value > 0 ? (
              <FiX
                size={18 * size}
                style={{
                  cursor: 'pointer',
                  marginRight: '3px',
                  opacity: 0.8,
                  pointerEvents: 'all',
                }}
                onClick={dateClear}
              />
            ) : null}
            <FiCalendar cursor={'pointer'} size={18 * size} />
          </Flex>
        </Flex>
      </React.Fragment>
    )
  },
)

export default DateRangeInput

export interface IDateRangeInputProps extends IFormElementProps {
  startDate?: Date
  sized?: boolean
  offsetLeft?: number
  offsetTop?: number
  disableMobileResizing?: boolean
  sizedOnMobile?: boolean
  selectedDay?: Date
  isClear?: boolean
  isCenterOnMobile?: boolean
  withEmptyOnStart?: boolean
  isWithError?: boolean
  changeDateOnDisable?: boolean
  rangeType?: RangeType
  complementaryValue?: Date
  onComplementaryValueChange?: (date: Date) => void
  disabledDays?: Date[]
  dateRangeRef?: MutableRefObject<HTMLDivElement>
  onClick?: MouseEventHandler
}

export { DateRangeInput }
